/**
 * Format a date object to YYYY-MM-DD string using local timezone
 * @param {Date} date - The date to format
 * @returns {string} Date string in YYYY-MM-DD format
 */
export function formatLocalDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

/**
 * Format a date object to a date key string (same as formatLocalDate)
 * @param {Date} date - The date to format
 * @returns {string} Date key in YYYY-MM-DD format
 */
export function formatDateKey(date) {
    return formatLocalDate(date);
}

/**
 * Format a date string to a human-readable format
 * @param {string} dateStr - Date string in YYYY-MM-DD format
 * @returns {string} Formatted date like "November 13, 2025"
 */
export function formatDisplayDate(dateStr) {
    const dateObj = new Date(dateStr + 'T00:00:00');
    return dateObj.toLocaleDateString('en-US', { 
        month: 'long', 
        day: 'numeric', 
        year: 'numeric' 
    });
}

/**
 * Get today's date in YYYY-MM-DD format using local timezone
 * @returns {string} Today's date in YYYY-MM-DD format
 */
export function getTodayDateString() {
    return formatLocalDate(new Date());
}
